import bus, { eventNames } from '@/lib/eventBus'

export const showSnackbarMessage = (type, text, texts) => {
  bus.$emit(eventNames.SHOW_SNACKBAR, {
    color: type,
    text: text,
    texts
  })
}
